import { toast } from 'react-toastify';
import { API } from '../config';
import { StnAPI } from '../config/customHeadersApi';
import {
	setAllSites,
	setAllSitesBySelectedCustomerID,
	setDeletedSite,
	setMainSiteByCustomerID,
	setNewSite,
	setReducerError,
	setSite,
	setSiteAccess,
	setSitesByCustomerID,
	// setCurrentSite,
	setSitesBySelectedCustomerID,
	setUpdatedSite,
	start,
} from '../reducers/sitesReducers';
import { getCurrentCustomer } from './customerActions';
import { useSiteId } from '../../utils/hooks/useCustomerId';
import { raiseErrorException } from '../../utils/raiseErrorException';

// Get ALl Site
export const getAllSites = () => async dispatch => {
	try {
		const response = await API.get('/sites/');

		return dispatch(setAllSites(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Create a Site
export const createSite = (site, form) => async dispatch => {
	try {
		const response = await API.post('/sites/', site);

		dispatch(setNewSite(response?.data));

		form.restart();
		toast.success('Site Created Successfully');
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'post');
	}
};
export const addSite = (data, siteID, customerID, toggle) => async dispatch => {
	try {
		console.log(data);
		const API_URL = siteID ? StnAPI : API;
		const response = await API_URL.put('/sites/create_sites/', data, {
			headers: {
				'x-customer-id': customerID,
				'x-site-id': siteID,
			},
		});

		dispatch(setNewSite(response?.data));
		toggle();
		dispatch(getAllSitesBySelectedCustomerID(customerID));
		toast.success('Site Created Successfully');
		dispatch(getSitesByCustomerID());
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'put');
	}
};

// Get Site with ID
export const getSiteByID = siteID => async dispatch => {
	try {
		const response = await API.get(`/sites/${siteID}`);

		return dispatch(setSite(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

export const getAllSitesWithIDS = sites => async dispatch => {
	try {
		dispatch(start());
		if (sites) {
			const response = await API.post('/sites/sites', {
				sites,
			});

			dispatch(setSiteAccess(response?.data));
		}
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'post');
	}
};

export const getSelectedSitesByID = access => async dispatch => {
	try {
		dispatch(start());
		const sites = access.map(s => s.key);
		const response = await API.post('/sites/sites', {
			sites,
		});

		return dispatch(setSite(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Update Site By ID
export const updateSiteByID = (updatedSite, siteID, siteIndex, setError, toggle) => async dispatch => {
	try {
		const response = await API.put(`/sites/${siteID}`, updatedSite);
		toast.success('Site has been updated successfully');

		dispatch(setUpdatedSite({ index: siteIndex, updatedSite: response?.data }));
		setError(false);
		toggle();
	} catch (err) {
		setError(err?.response?.data?.detail);
		raiseErrorException(err, dispatch, setReducerError, 'put');
	}
};

// Update Site By ID
export const updateSite = (data, siteID, customerID, toggle) => async dispatch => {
	try {
		const API_URL = siteID ? StnAPI : API;
		const response = await API_URL.put(`/sites`, data, {
			headers: {
				'x-customer-id': customerID,
				'x-site-id': siteID,
			},
		});
		toast.success('Site has been updated successfully');
		dispatch(getSitesByCustomerID());
		toggle();
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'put');
	}
};

// Update Site By ID
export const updateCompanyInfoBySiteID = (customerID, siteID, data, toggle) => async dispatch => {
	try {
		const response = await StnAPI.put(`/sites`, data, {
			headers: {
				'x-customer-id': customerID,
				'x-site-id': siteID,
			},
		});
		toast.success('Updated Company Information successfully');
		dispatch(getCurrentCustomer());
		dispatch(getSitesByCustomerID());
		toggle();
	} catch (err) {
		// const errorMsg = err?.response?.data?.detail[0]?.msg || err?.response?.data?.detail;
		// toast.error(errorMsg);
		raiseErrorException(err, dispatch, setReducerError, 'put');
	}
};

// Delete site with ID
export const deleteSiteByID = (siteID, siteIndex) => async dispatch => {
	try {
		await API.delete(`/sites/${siteID}`);
		toast.success('Site Deleted Successfully');

		return dispatch(setAllSites(siteIndex));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'delete');
	}
};
// Delete site with ID
export const deleteSite = (siteID, customerID) => async dispatch => {
	try {
		const API_URL = siteID ? StnAPI : API;
		await API_URL.delete(`/sites/`, {
			headers: {
				'x-customer-id': customerID,
				'x-site-id': siteID,
			},
		});
		toast.success('Site Deleted Successfully');
		dispatch(getAllSitesBySelectedCustomerID(customerID));

		dispatch(getSitesByCustomerID());
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'delete');
	}
};

// Get Sites by Customer ID
export const getSitesByCustomerID = customerID => async dispatch => {
	try {
		let headers = {};
		let API_URL;
		if (customerID) {
			console.log('customerID__', customerID);
			headers['x-customer-id'] = customerID;
			headers['x-site-id'] = 'all';
		}
		API_URL = customerID ? StnAPI : API;
		console.log('API_URL', API_URL);
		console.log('headers', headers);
		const response = await API_URL.get(`/sites/customer/`, { headers });
		return dispatch(setSitesByCustomerID(response?.data));
	} catch (err) {
		dispatch(setSitesByCustomerID([]));
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get Sites by Customer ID
export const getSitesBySelectedCustomerID = customerID => async dispatch => {
	try {
		const response = await StnAPI.get(`/sites/customer/`, {
			headers: {
				'x-customer-id': customerID,
				'x-site-id': useSiteId(),
			},
		});

		return dispatch(setSitesBySelectedCustomerID(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};
export const sitesBySelectedCustomerID = customerID => async dispatch => {
	try {
		const response = await StnAPI.get(`/sites/customer/`, {
			headers: {
				'x-customer-id': customerID,

				// 'x-site-id': getLocalStorageData('currentSiteID'),
			},
		});

		return dispatch(setSitesBySelectedCustomerID(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// Get All Sites by Customer ID
export const getAllSitesBySelectedCustomerID = customerID => async dispatch => {
	try {
		const response = await StnAPI.get(`/sites/customer/all`, {
			headers: {
				'x-customer-id': customerID,
				'x-site-id': useSiteId(),
			},
		});

		return dispatch(setAllSitesBySelectedCustomerID(response?.data));
	} catch (err) {
		if (err?.response?.status === 403) {
			try {
				const response = await StnAPI.get('/sites/customer', {
					headers: {
						'x-customer-id': customerID,
						'x-site-id': useSiteId(),
					},
				});
				dispatch(setAllSitesBySelectedCustomerID(response?.data));
			} catch (secondErr) {
				raiseErrorException(secondErr, dispatch, setReducerError, 'get');
			}
		} else {
			raiseErrorException(err, dispatch, setReducerError, 'get');
		}
	}
};

// Get main Site by Customer ID
export const getMainSiteByCustomerID = customerID => async dispatch => {
	try {
		const response = await API.get(`/sites/customer/main`);
		return dispatch(setMainSiteByCustomerID(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

export const getAccessibleSites = () => async dispatch => {
	try {
		const response = await API.get('/sites/access/user');

		return dispatch(setAllSites(response?.data));
	} catch (err) {
		raiseErrorException(err, dispatch, setReducerError, 'get');
	}
};

// reset site state - not on API
export const resetDeletedSiteState = () => async dispatch => {
	dispatch(setDeletedSite(null));
};
